module.exports = __webpack_public_path__ + "static/media/IMG_20200611_135111.05ae4011.webp";